var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0554 33.0587C12.0243 33.5873 11.5866 34 11.0571 34H2.94291C2.41343 34 1.97572 33.5873 1.94463 33.0587L0.0622778 1.05872C0.0284908 0.484343 0.48518 0 1.06055 0H12.9394C13.5148 0 13.9715 0.484342 13.9377 1.05872L12.0554 33.0587Z",
    fill: "#515A60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0554 33.0587C32.0243 33.5873 31.5866 34 31.0571 34H22.9429C22.4134 34 21.9757 33.5873 21.9446 33.0587L20.0623 1.05872C20.0285 0.484343 20.4852 0 21.0606 0H32.9394C33.5148 0 33.9715 0.484342 33.9377 1.05872L32.0554 33.0587Z",
    fill: "#515A60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.e24143d08ac45f82b4c5dc4a9440dd42.svg";
export { ForwardRef as ReactComponent };